import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { LiveDataCommandEnum } from "../live-data-service/Models";



export enum NotificationMessageTypeEnum {
    UserMessage = 1,
    ExportMessage = 2,
    LiveDataStatusMessage = 3,
    DataFileImportLog = 4,
    ObjectAdminLog = 5,
    QuickTrendJSON = 6,
    ReportingJSON = 7,
    TrendingJSON = 8
}

export enum NotificationMessagePriorityEnum {
    Info = 0,
    //Priority = 1
    High = 1
}


export interface INotificationMessageModel {
    id: number;
    header: string;
    description: string;
    messageType: NotificationMessageTypeEnum;
    messageDate: Date | undefined;
    messageExpirationDate: Date | undefined;
    acknowledged: Date;
    uri: string;
    priority: NotificationMessagePriorityEnum;
    mimeType: ApplicationMimeTypesEnum;
    command: LiveDataCommandEnum;
    success: boolean;
    requestID: string;
}